// @ts-nocheck
import { TrackFileDownloadParameters } from "@store/Framework/GoogleAnalytics/trackers/trackFileDownload";
import ga from "@toolkit/Framework/Common/GoogleAnalytics";

const useTrackFileDownload = (
    parameters: TrackFileDownloadParameters = {},
    options?: Toolkit.GoogleAnalytics.Options,
) => ga.util.getEventTrackerHook(ga.track.fileDownload, parameters, options);

export default useTrackFileDownload;
